// extracted by mini-css-extract-plugin
export default {"emptyContainer":"Books_emptyContainer__emZ-f","container":"Books_container__Kt1nO"};